import { InvoiceFilterIcon } from "~/features/Invoices/constants/invoiceTableIcons";
import {
  CreatedByFilterObj,
  getFacilityFilterObj,
  INVOICE_AMOUNT,
  INVOICE_DATE,
  INVOICE_DUE_DATE,
  INVOICE_ISSUE_DATE,
  INVOICE_STATUS,
  INVOICE_WORK_ORDER,
} from "./filters";

export const InvoiceStatusFilterObj = {
  id: INVOICE_STATUS,
  name: "Status",
  icon: InvoiceFilterIcon.status,
};

export const InvoiceDateFilterObj = {
  id: INVOICE_DATE,
  name: "Created at",
  icon: InvoiceFilterIcon.calendar,
};

export const InvoiceAmountFilterObj = {
  id: INVOICE_AMOUNT,
  name: "Amount",
  icon: InvoiceFilterIcon.amount,
};

export const InvoiceIssueDateFilterObj = {
  id: INVOICE_ISSUE_DATE,
  name: "Invoice Date",
  icon: InvoiceFilterIcon.calendar,
};

export const InvoiceDueDateFilterObj = {
  id: INVOICE_DUE_DATE,
  name: "Due Date",
  icon: InvoiceFilterIcon.calendar,
};

export const InvoiceWorkOrderFilterObj = {
  id: INVOICE_WORK_ORDER,
  name: "Work Order",
  icon: InvoiceFilterIcon.workOrder,
};

export const InvoiceCompanyFilterObj = {
  ...getFacilityFilterObj(),
  icon: InvoiceFilterIcon.company,
};

export const InvoiceCreatedByFilterObj = {
  ...CreatedByFilterObj,
  icon: InvoiceFilterIcon.createdBy,
};

/** Required filters for invoices list — Work Order included by default (AC). */
export const financeInvoicesDefaultFilters = [
  InvoiceStatusFilterObj,
  InvoiceCompanyFilterObj,
  InvoiceWorkOrderFilterObj,
  InvoiceDateFilterObj,
  InvoiceAmountFilterObj,
  InvoiceIssueDateFilterObj,
  InvoiceDueDateFilterObj,
  InvoiceCreatedByFilterObj,
];
